// extracted by mini-css-extract-plugin
export default {"link":"VKX2AzNCn0P2Toh5CY92","body":"qfbPbLXKIkLszbcBoPls","buttonBox":"vSMo8BA0G7LkvmcmoIO0","yesButton":"Unbn9uKUvJgs7TCfWlcj"};